import React, { useEffect } from 'react';
import { initLocalNotifications, setupNotificationTapListener } from '../utils/initLocalNotifications';

/**
 * Runs once: init local notification channel and listen for notification tap.
 * On tap, sets orderIdToOpen — GlobalOrderDetailModal shows order details without leaving the current screen.
 */
export default function NotificationListener() {
  useEffect(() => {
    initLocalNotifications();
    const cleanup = setupNotificationTapListener();
    return cleanup;
  }, []);

  return null;
}
